import React from "react";
import { Col, Container, Row } from "react-bootstrap";
import TrustedImg from "../../images/location_new/fold11/Washington.webp";
import { LazyLoadImage } from "react-lazy-load-image-component";
import { Link } from "gatsby";

function Trustedcompany(props) {
  return (
    <div className="trusted_company p-100">
      <Container className="h-100">
        <Row className="h-100">
          <Col xs={12} md={12} lg={6} xl={6} xxl={6} className="my-auto">
            <h2>
              Empowering Washington DC with Tailored Software Development
              Solutions
            </h2>
            <p>
              As a forerunner in the custom software development arena in
              Washington DC, TekRevol delivers supreme skills, incorporating
              revolutionary improvements and unique features while adhering to
              top-tier coding practices. With a solid reputation in Washington
              DC, we push businesses to attain their goals through trailblazing
              digital solutions and expert consultation, using innovative
              technology to improve their competitive edge.
            </p>
            <p>
              Our dedicated aftersales support and safe cloud-based hosting
              ensure a seamless digital journey. TekRevol emphasizes in
              empowering enterprises with front-line, user-friendly software
              solutions, paving the way for considerable revenue growth.
            </p>
            <p>
              Start your digital transformation journey with us today, and let's
              transform your business in the upcoming digital future.
            </p>
            <Link
              to="/contact"
              className="border_btn dark_btn"
              aria-label="TekRevol Contact"
              rel="noopener"
            >
              Let's Connect!
            </Link>
          </Col>
          <Col xs={12} md={12} lg={6} xl={6} xxl={6} className="my-auto">
            <div className="trustedimg">
              <LazyLoadImage
                src={TrustedImg}
                effect="blur"
                alt="TrustedImg"
                className="img-fluid"
              />
            </div>
          </Col>
        </Row>
      </Container>
    </div>
  );
}

export default Trustedcompany;
